module.exports = "//public.zight.com/packs/media/images/download_icon_chrome-df30f1a07d4e4cbb3dc4ff3b175a60b1.svg";